import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../app/store';

import { isMessageErrorSelector, setIsMessageError } from '../../../app/store';

const useTicketErrorHandlers = (errorSendMessage: any) => {
    const dispatch = useAppDispatch();
    const isMessageError = useAppSelector(isMessageErrorSelector);

    useEffect(() => {
        dispatch(setIsMessageError(errorSendMessage));
    }, [errorSendMessage]);

    return { isMessageError };
};

export default useTicketErrorHandlers;
